import React, { useState, useEffect } from "react";
import Header from "./Header/Header";
import FolderList from "./FolderList/FolderList";
import FileList from "./FileList/FileList";
import Grid from "@material-ui/core/Grid";
import MateService from "../../../services/MateDriveService/MateDriveService";


/**
 * @Description this page MateDrive(Data Store) Development
 * @Param       flowId - object
 * @Param       flow - autom flow
 * @Param       setOpen -  close or open modal
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function FileManager(props) {
    const [pathName, setPathName] = useState("");
    const [selectItem, setSelectItem] = useState(null);
    const [selectFileItem, setSelectFileItem] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [data, setData] = useState([]);
    const [folderData, setFolderData] = useState([]);
    const [render, setRender] = useState(false);
    const [isFileSelect, setIsFileSelect] = useState(false);
    const [isFolderSelect, setIsFolderSelect] = useState(true);

    useEffect(() => {
        async function handleChangePath() {
            const resp = await MateService.getFilterMateService(
                "FILELIST",
                pathName,
                "",
                "",
                props.flowId
            );
            if (resp) {
                if (folderData.length === 0 || render) {
                    const respx = await MateService.getFilterMateService(
                        "FILELIST",
                        "",
                        "",
                        "",
                        props.flowId
                    );
                    if (respx?.data?.length > 0 && render === "delete" && isFolderSelect) {
                        let parsedData = JSON.parse(respx.data);
                        parsedData.name = "Root";
                        setFolderData(parsedData);
                        setSelectItem(parsedData)
                    }
                    else if (respx?.data?.length > 0 && render === "createFolder") {
                        let parsedData = JSON.parse(respx.data);
                        parsedData.name = "Root";
                        setFolderData(parsedData);
                    }
                    else if (((respx?.data?.length > 0 && render.length) || folderData.length === 0) && render !== "delete") {
                        let parsedData = JSON.parse(respx.data);
                        parsedData.name = "Root";
                        setFolderData(parsedData);
                        setSelectItem(parsedData)
                    }
                }
                if (resp?.data?.length > 0 && (selectItem?.is_dir || render === "delete")) {
                    setData(JSON.parse(resp.data));
                }
            }
        }

        handleChangePath().then(r => r);
        setRender(false);
    }, [selectItem, props.flowId, render]);


    return (
        <div style={{ marginTop: 10 }} className="matedrive">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Header
                        setRender={setRender}
                        selectItem={selectItem}
                        selectedItems={selectedItems}
                        setSelectItem={setSelectItem}
                        setSelectFileItem={setSelectFileItem}
                        selectFileItem={selectFileItem}
                        setSelectedItems={setSelectedItems}
                        flowId={props?.flowId}
                    />
                </Grid>
                <Grid item xs={3}>

                    <FolderList
                        data={folderData}
                        pathName={pathName}
                        setPathName={setPathName}
                        setSelectItem={setSelectItem}
                        setSelectedItems={setSelectedItems}
                        handleSelectFolder={() => {
                            setIsFileSelect(false)
                            setIsFolderSelect(true)
                        }}
                        from={props.from}
                    />
                </Grid>
                <Grid item xs={9} className="matedrive-file-list" style={{ marginBottom: 10 }}>
                    <FileList
                        data={data.children}
                        pathName={pathName}
                        setSelectItem={setSelectItem}
                        setSelectedItems={setSelectedItems}
                        selectItem={selectItem}
                        selectedItems={selectedItems}
                        setSelectFileItem={setSelectFileItem}
                        selectFileItem={selectFileItem}
                        isFileSelect={isFileSelect}
                        isFolderSelect={isFolderSelect}
                        handleSelectFile={() => {
                            setIsFileSelect(true)
                            setIsFolderSelect(false)
                        }}
                        from={props.from}
                        handleOnChange={props.handleOnChange}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
